import { Box, Button, Grid, Typography } from "@mui/material";
import collection_of_machines from "../Images/Machines/collection_of_machine.png";
import Navbar2 from "../Navbar/Navbar2";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const navigate = useNavigate();

  return (
    <div>
      <Navbar2 />
      <Box
        sx={{
          width: "100%",
          minHeight: "88vh",
          display: "flex",
          alignItems: "center",
          backgroundColor: "#ffffff",
        }}
      >
        <Grid container alignItems='center'>
          {/* LEFT CONTENT */}
          <Grid
            size={{ lg: 5, xs: 12, md: 12, sm: 12 }}
            sx={{ paddingLeft: 10 }}
          >
            <Typography
              sx={{
                fontSize: { xs: "1.8rem", md: "2.5rem" },
                fontWeight: 700,
                color: "#2b2b2b",
                lineHeight: 1.2,
                fontFamily: "Poppins, sans-serif",
              }}
            >
              Welcome to <br />
              <Box component='span' sx={{ color: "#144FEE" }}>
                Elantris Technologies
              </Box>
              <br />
              Connected Solutions{" "}
            </Typography>

            <Typography
              sx={{
                mt: 2,
                fontSize: "1rem",
                color: "#555",
                maxWidth: 480,
                fontFamily: "Poppins, sans-serif",
              }}
            >
              Elantris Technologies provides equipment-agnostic IIoT solutions
              that connect all your construction and industrial machines into
              one platform. Get real-time data, monitoring, and insights to make
              your fleet smarter and more productive.
            </Typography>

            <Button
              variant='contained'
              sx={{
                mt: 3,
                backgroundColor: "#144FEE",
                textTransform: "none",
                px: 2.8,
                py: 1.1,
                fontSize: "1rem",
                borderRadius: "6px",
                fontFamily: "Poppins, sans-serif",
                "&:hover": {
                  backgroundColor: "#144FEE",
                },
                boxShadow: "none",
              }}
              onClick={() => {
                navigate("/MachineList");
              }}
            >
              Manage Your Machines
            </Button>

            {/* STORE BUTTONS */}
            {/* <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
              <img
                src='https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg'
                alt='App Store'
                height={40}
              />
              <img
                src='https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg'
                alt='Google Play'
                height={40}
              />
            </Box> */}
          </Grid>

          {/* RIGHT IMAGE */}
          <Grid size={{ lg: 7, xs: 12, md: 12, sm: 12 }}>
            <Box
              sx={{
                position: "relative",
                width: "100%",
                overflow: "hidden",
                borderRadius: "8px",
              }}
            >
              {/* IMAGE */}
              <Box
                component='img'
                src={collection_of_machines}
                alt='Hero'
                sx={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />

              {/* WHITE SHADOW / FADE */}
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "50%", // fade width
                  height: "100%",
                  background:
                    "linear-gradient(to right, rgba(255,255,255,1), rgba(255,255,255,0))",
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default Home;
